export const Lainie = {
  eot: require('./lainie.eot'),
  ttf: require('./lainie.ttf'),
  woff: require('./lainie.woff'),
};
